import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageStatusCodeEvent extends Layout {
    sourceBrokerageStatusEvent: DataSource;
    tableBrokerageStatusEvents: Table;
}
